import { useContext } from 'react';

import {
  ScreenDimensions,
  ScreenResponsiveLayoutContext,
} from '../providers/ScreenResponsiveLayoutProvider';

export const useGetScreenDimensions = (): ScreenDimensions =>
  useContext(ScreenResponsiveLayoutContext);
